
import { defineComponent, PropType } from "vue";
import {
  saveCameraConfiguration,
  saveCameraConfigurationHistory,
} from "@/service/cameraConfiguration.service";
import { CameraConfiguration, CameraConfigurationHistory } from "@/types/cameraconfiguration.type";
import { ElMessage } from "element-plus";

export default defineComponent({
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    configuration: {
      type: Object as PropType<CameraConfiguration>,
      required: true,
    },
    data: {
      type: Object as PropType<CameraConfigurationHistory>,
      required: true,
    },
    // entity: {
    //   type: Object as PropType<CameraConfiguration>,
    // },
  },
  setup() {
    return {
      options: [
        { label: 0, value: 0 },
        { label: 90, value: 90 },
        { label: 180, value: 180 },
        { label: 270, value: 270 },
      ],
    };
  },

  data() {
    return {
      entity: {} as CameraConfiguration,
    };
  },

  async mounted() {
    this.entity = Object.assign({}, this.configuration);
  },

  methods: {
    async save() {
      saveCameraConfiguration(this.entity).then(() => {
        ElMessage.success(this.$t("success.action"));
        this.close();
      });
      await saveCameraConfigurationHistory(this.data);
    },

    close() {
      this.$emit("close");
    },
  },
});
